import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {LinkpileComponent as Linkpile} from '../../common/linkpile/Linkpile';

export function mapStateToProps(state) {
    return {
        linkPiles: state.modules.linkPiles
    };
}

export function LinkPilesComponent({linkPiles}) {
    return (<Fragment>
        {linkPiles.map(({
            heading,
            hideTabs = true,
            tabs
        }, index) => {
            return (
                <Linkpile
                    heading={heading}
                    hideTabs={hideTabs}
                    tabs={tabs}
                    key={`linkpile-${index}`}
                />
            );
        })}
    </Fragment>);
}

export const LinkPiles = connect(mapStateToProps)(LinkPilesComponent);
